import { z } from 'zod';

export const pinnedImageSchema = z.object({
  imageReference: z.string().min(1).max(255).regex(/^[a-z0-9]+(?:[._:/-][a-z0-9]+)*$/)
    .refine((value) => value.trim() === value),
  imageDigest: z.string().length(71).regex(/^sha256:[a-f0-9]{64}$/),
});

export const templateDefaultsSchema = z.object({
  memoryMb: z.number().int().min(128).max(65536).default(512),
  cpus: z.number().finite().min(0.1).max(64).default(1),
  language: z.string().regex(/^[a-z]{2,3}(?:_[A-Z]{2})?$/).default('en_US'),
  timezone: z.string().max(80).refine((value) => {
    try { new Intl.DateTimeFormat('en', { timeZone: value }); return true; } catch { return false; }
  }).default('UTC'),
  plugins: z.array(z.string().max(120).regex(/^[a-z0-9-]+@[0-9]+\.[0-9]+(?:\.[0-9]+)?$/)).max(50).default([]),
  theme: z.string().max(120).regex(/^[a-z0-9-]+@[0-9]+\.[0-9]+(?:\.[0-9]+)?$/).optional(),
  /** PHP limits for the template's sites (P9); absent means the standard ones. */
  php: z.object({
    uploadMaxMb: z.number().int().min(2).max(1024),
    postMaxMb: z.number().int().min(2).max(1024),
    memoryLimitMb: z.number().int().min(64).max(4096),
    maxExecutionSeconds: z.number().int().min(10).max(600),
  }).strict().optional(),
}).strict();

export const publishTemplateSchema = pinnedImageSchema.extend({
  name: z.string().trim().min(1).max(120),
  engine: z.literal('wordpress'),
  version: z.string().max(80).regex(/^[0-9]+\.[0-9]+\.[0-9]+(?:-[a-z0-9.-]+)?$/)
    .refine((value) => value.trim() === value),
  defaults: templateDefaultsSchema.default({}),
  changelog: z.string().max(4000).optional(),
}).strict();

export type PublishTemplateInput = z.infer<typeof publishTemplateSchema>;
export type TemplateDefaults = z.infer<typeof templateDefaultsSchema>;
